import logging from "utils/logging";
import { doc, onSnapshot, updateDoc, collection, serverTimestamp } from "firebase/firestore";
import utils from "./firebaseUtils";
import {
  FIREBASE_COLLECTION_GAMES,
  FIREBASE_COLLECTION_QUESTIONS,
  FIREBASE_FUNCTION_RESET_QUESTION,
  FIREBASE_FUNCTION_SELECT_QUESTION,
} from "./constants";
import { loadDiffOfModelsForQuerySnapshot } from "./firebaseModels";

const log = logging.getLogger("firebase/question");
log.setLevel('info');

const watchQuestionsForGameId = (gameId, onChange) => {
  log.debug("Watching questions for game: ", gameId);

  const questionsCollection = collection(utils.db(), FIREBASE_COLLECTION_GAMES, gameId, FIREBASE_COLLECTION_QUESTIONS);

  return onSnapshot(questionsCollection, async (qSnap) => {
    let diff = await loadDiffOfModelsForQuerySnapshot(qSnap);
    log.debug("Got diffed questions: ", diff);
    onChange(diff);
  });
};

const markQuestionSelected = async (gameId, questionId) => {
  log.debug(`Marking question as selected: ${questionId}`);
  const questionsRef = doc(utils.db(), FIREBASE_COLLECTION_GAMES, gameId, FIREBASE_COLLECTION_QUESTIONS, questionId);

  await updateDoc(questionsRef, {
    status: "active",
    picked: true,
  });
  log.debug(`Question ${questionId} marked with picked=true and status=active`);
};

const selectQuestion = async (gameId, questionId) => {
  const selectQuestionFunc = utils.getCallableFunction(FIREBASE_FUNCTION_SELECT_QUESTION);
  const result = await selectQuestionFunc({ gameId, questionId });
  return result.data;
};

const markQuestionOpenForSubmissions = async (gameId, questionId, endTime) => {
  const questionsRef = doc(utils.db(), FIREBASE_COLLECTION_GAMES, gameId, FIREBASE_COLLECTION_QUESTIONS, questionId);

  await updateDoc(questionsRef, {
    status: "active",
    picked: true,
    endTime: endTime,
    startTime: serverTimestamp(),
  });
};

const markQuestionPicked = async (gameId, questionId) => {
  log.debug(`Marking question as picked: ${questionId}`);
  const questionsRef = doc(utils.db(), FIREBASE_COLLECTION_GAMES, gameId, FIREBASE_COLLECTION_QUESTIONS, questionId);

  await updateDoc(questionsRef, {
    picked: true,
  });
  log.debug(`Question ${questionId} marked with picked=true`);
};

const resetQuestion = async (gameId, questionId) => {
  log.debug(`Resetting question: ${questionId}`);
  const resetQuestionFunc = utils.getCallableFunction(FIREBASE_FUNCTION_RESET_QUESTION);
  const result = await resetQuestionFunc({ gameId, questionId });
  log.debug(`Question ${questionId} reset result:`, result);
  return result;
};

const api = {
  watchQuestionsForGameId,
  selectQuestion,
  markQuestionSelected,
  markQuestionOpenForSubmissions,
  markQuestionPicked,
  resetQuestion,
};

export default api;
